export enum MaterialDatepickerType {
    FULL_DATE = 'FULL_DATE', // day, month and year picker
    YEAR = 'YEAR',
}
